/** 
 * The functions in this file will not be included in production-bound builds
 */

/**
 * Writes a message to console.log().
 * @customfunction
 * @helpurl https://scottsaddins.com/faq
 * @param message String to write.
 * @returns String to write.
 */
export function LOG(message: string): string {
  console.log(message);
  return message;
}